import React from "react";
import useTranslation from "@hooks/use_translation";
import TaskCard from "./TaskCard";
import type { Task } from "@/types/task";

interface TaskCardProps {
  task: Task;
  statusText: string;
}

const SetupAccount: React.FC<TaskCardProps> = ({ task, statusText }) => {
  const { t } = useTranslation("tasks");

  return (
    <TaskCard
      statusText={statusText}
      task={task}
      title={t("setupAccount.title")}
      description={t("setupAccount.description")}
      actionHref="/account"
      actionText={t("setupAccount.finishSetup")}
      externalLink={false}
    />
  );
};

export default SetupAccount;
